import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Chip,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Cross } from "../../shared/assets/icons";
import CustomInput from "../../shared/utils/Input";
import GlobalDropdownField from "../../shared/utils/GlobalDropdownField";
import { statecityData } from "../../shared/enums";
import GlobalButton from "../../shared/utils/GlobalButton";

const ClientEditAddModal = ({
  setAnchorEl,
  emailDomain,
  updateClientId,
  open,
  selectedClientDetails,
  setarrayOfClients,
  arrayOfClients,
  setselectedCompany,
  setOpen,
  organizationId,
}) => {
  const serverURL = process.env.REACT_APP_URL;
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [loading, setLoading] = useState(false); // Add loading state
  const [cityArray, setCityArray] = useState([]);
  const isEdit = !!selectedClientDetails?._id;
  const cityApiKey = process.env.REACT_APP_FETCH_STATE_CITY_API_KEY;

  const [contactDetails, setContactDetails] = useState({
    name: selectedClientDetails?.name || "",
    emailAddress: selectedClientDetails?.emailAddress || "",
    state: selectedClientDetails?.state || "",
    city: selectedClientDetails?.city || "",

    phoneNumber: selectedClientDetails?.phoneNumber || "",
    organizationId: organizationId,
    clientAddress: selectedClientDetails?.clientAddress || "",
    // roleInOrganization: selectedClientDetails?.roleInOrganization || "",
    associatedBrands: selectedClientDetails?.associatedBrands || [], // Ensure this is initialized correctly
    isClientOnBoarded: true,
    userRoleId: selectedClientDetails?.userRoleId || "",
  });

  useEffect(() => {
    const stateCode = statecityData.find(
      (ele) => ele.name === contactDetails.state,
    )?.iso2;

    if (contactDetails.state) {
      const fetchCities = async (stateCode) => {
        const headers = new Headers();
        headers.append("X-CSCAPI-KEY", cityApiKey);

        const requestOptions = {
          method: "GET",
          headers: headers,
          redirect: "follow",
        };

        try {
          const response = await fetch(
            `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
            requestOptions,
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const cityData = await response.json();
          setCityArray(cityData);
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      fetchCities(stateCode);
    }
  }, [contactDetails.state]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [errors, setErrors] = useState({});

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const validateForm = () => {
    const newErrors = {};
    // Check required fields
    if (!contactDetails.name) newErrors.name = "Name is required";

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // General email pattern
    const restrictedDomains = ["gmail.", "yahoo", "hotmail"]; // Domains you want to restrict

    const enteredEmail = contactDetails.emailAddress || "";

    if (!enteredEmail || !emailPattern.test(enteredEmail)) {
      newErrors.emailAddress = "Enter a valid email address";
    } else {
      const enteredDomain = enteredEmail.split("@")[1]; // Get domain from entered email

      // Check if the entered domain exists and is not in the restricted domains
      if (
        enteredDomain &&
        !restrictedDomains.some((restrictedDomain) =>
          enteredDomain.toLowerCase().includes(restrictedDomain),
        )
      ) {
        // Check if emailDomain is not empty before comparing
        if (emailDomain === "") {
          // Do nothing or set a message if needed
          // e.g., newErrors.emailAddress = ""; // Not needed as emailDomain is empty
        } else if (enteredDomain.toLowerCase() !== emailDomain.toLowerCase()) {
          newErrors.emailAddress = "Please enter company domain email";
        }
      } else {
        newErrors.emailAddress = "Email from this domain is not allowed"; // Custom error for restricted domains
      }
    }
    // if (!contactDetails.roleInOrganization) {
    //   newErrors.roleInOrganization = "Enter Your role";
    // }
    if (!contactDetails.userRoleId) {
      newErrors.userRoleId = "Please Select Role Id";
    }

    if (
      !contactDetails.phoneNumber ||
      !/^\d{10}$/.test(contactDetails.phoneNumber)
    )
      newErrors.phoneNumber = "Valid Contact No is required";

    if (!contactDetails.clientAddress) {
      newErrors.clientAddress = "Address required";
    }
    if (!contactDetails.state) {
      newErrors.state = "State is required";
    }
    if (!contactDetails.city) {
      newErrors.city = "City is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };
  const handleKeyPress = (e) => {
    const { name, type } = e.target;
    const charCode = e.keyCode || e.which;

    if (name === "userName") {
      // Block characters that are not letters or spaces for the name input
      if (/[^a-zA-Z\s]/.test(e.key)) {
        e.preventDefault();
      }
    } else if (type === "number" || name === "phoneNumber") {
      // Block 'e', 'E', '-', '+', and '.' for phone number input
      if ([69, 101, 43, 45, 46].includes(charCode)) {
        e.preventDefault();
      }
    }
  };

  const handleSubmit = async (e) => {
    setAnchorEl(null);

    e.preventDefault();

    if (!validateForm()) {
      // Form validation failed
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text: "Something Went Wrong",
        color: "black",
      });
      return; // Stop further execution if validation fails
    }

    setLoading(true);

    try {
      if (isEdit) {
        // If we're editing an existing client
        const response = await axios.put(
          `${serverURL}/client/edit/${selectedClientDetails._id}`,
          contactDetails,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        if (response.data.success) {
          Swal.fire({
            customClass: {
              container: "my-swal",
            },
            icon: "success",
            text: response.data.message,
            padding: "1em",
            color: "black",
          }).then(() => {
            const updatedClients = arrayOfClients.map((client) =>
              client._id === updateClientId ? response.data.data : client,
            );
            setAnchorEl(null);

            setselectedCompany((prevCompany) => ({
              ...prevCompany,
              clientUsers: updatedClients,
            }));

            // Update the arrayOfClients state
            setarrayOfClients(updatedClients);

            // Close the modal
            setOpen(false); // Close the modal after success
          });
        }
      } else {
        // If we're adding a new client
        const response = await axios.post(
          `${serverURL}/client/create`,
          contactDetails,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        if (response.data.success) {
          Swal.fire({
            customClass: {
              container: "my-swal",
            },
            icon: "success",
            text: response.data.message,
            padding: "1em",
            color: "black",
          }).then(() => {
            const updatedClients = [...arrayOfClients, response.data.data];
            // setarrayOfClients(updatedClients);

            setselectedCompany((prevCompany) => ({
              ...prevCompany,
              clientUsers: updatedClients,
            }));

            setOpen(false);
            // setIsCompanyDetailsModal(false);
          });
        }
      }
    } catch (error) {
      console.error("Error in client operation:", error);
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text: error.response?.data?.message || "An error occurred",
        color: "var(--heading-color)",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <div className="flex justify-between items-center">
        <DialogTitle>
          <h3 className="mt-2">Client Details </h3>
        </DialogTitle>
        <div onClick={handleClose} className="mx-5 my-4 cursor-pointer">
          <Cross />
        </div>
      </div>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-2 gap-6 ml-5 ">
            <div className="flex flex-col">
              <CustomInput
                name="name"
                placeholder="Enter Full Name"
                title="First Name*"
                value={contactDetails?.name}
                size="small"
                required
                onChange={(e) => {
                  if (!e.target.value.startsWith(" ")) {
                    handleInputChange(e);
                  }
                }}
                onBlur={(e) => {
                  if (saveButtonClicked) {
                    validateForm();
                  }
                }}
                // errorMessage={"Please Enter Full Name"}
                error={errors.name}
                // helperTextColor= "#ff5555"
              />
              {errors.name && (
                <FormHelperText
                  className=" ml-4"
                  style={{ color: "var(--error-color) !important" }}
                >
                  Please Enter Full Name
                </FormHelperText>
              )}
            </div>

            {/* <div>
              <GlobalDropdownField
                name="roleInOrganization"
                label="Role*"
                value={contactDetails?.roleInOrganization || ""}
                onChange={handleInputChange}
                placeholder="Select Role"
                options={[
                  { value: "Marketing Manager", label: "Marketing Manager" },
                  {
                    value: "Chief Marketing Manager",
                    label: "Chief Marketing Manager",
                  },
                  { value: "Client", label: "Client" },
                ]}
                error={errors.roleInOrganization}
                variant="citySelect"
                renderValueFn={(selected) => {
                  if (!selected || selected.length === 0) {
                    return (
                      <span
                        className="text-[17px]"
                        style={{ color: "var(--listdown-color)" }}
                      >
                        Select Role
                      </span>
                    );
                  }

                  return (
                    <span style={{ color: "var(--heading-color)" }}>
                      {selected}
                    </span>
                  );
                }}
              />
            </div> */}
            <div>
              <GlobalDropdownField
                name="userRoleId"
                label="User Role Id*"
                value={contactDetails?.userRoleId || ""}
                onChange={handleInputChange}
                placeholder="Select Role Id"
                options={[
                  // { value: 1, label: "Super Admin" },
                  { value: 2, label: "Admin" },
                ]}
                error={errors.userRoleId}
                variant="citySelect"
                errorMessage={errors.userRoleId}
                renderValueFn={(selected) => {
                  if (!selected || selected.length === 0) {
                    return (
                      <span
                        className="text-[17px]"
                        style={{ color: "var(--listdown-color)" }}
                      >
                        Select Role Id
                      </span>
                    );
                  }

                  const roleNames = {
                    // 1: "Super Admin",
                    2: "Admin",
                  };

                  return (
                    <span style={{ color: "var(--heading-color)" }}>
                      {roleNames[selected]}
                    </span>
                  );
                }}
              />
            </div>
            <div className=" flex flex-col">
              <CustomInput
                name="emailAddress"
                placeholder="Enter Your Mail"
                title="Company Mail*"
                value={contactDetails?.emailAddress}
                size="small"
                required
                onChange={(e) => {
                  if (!e.target.value.startsWith(" ")) {
                    handleInputChange(e);
                  }
                }}
                onBlur={(e) => {
                  if (saveButtonClicked) {
                    validateForm();
                  }
                }}
                // errorMessage={"Please Enter Company Email"}
                error={errors.emailAddress}
              />
              {errors.emailAddress && (
                <FormHelperText
                  className=" ml-4"
                  style={{ color: "var(--error-color) !important" }}
                >
                  {errors.emailAddress}
                </FormHelperText>
              )}
            </div>
            <div className=" flex flex-col">
              <CustomInput
                name="phoneNumber"
                placeholder="Enter Mobile Number"
                title="Mobile Number*"
                value={contactDetails?.phoneNumber}
                size="small"
                type="number"
                required
                onChange={(e) => {
                  if (
                    !e.target.value.startsWith(" ")
                    //  &&
                    // e.target.value.length < 11
                  ) {
                    handleInputChange(e);
                  }
                }}
                onBlur={(e) => {
                  if (saveButtonClicked) {
                    validateForm();
                  }
                }}
                onKeyPress={(e) => handleKeyPress(e)}
                // errorMessage={"Please Enter Mobile Number"}
                error={errors.phoneNumber}
              />
              {errors.phoneNumber && (
                <FormHelperText
                  className=" ml-4"
                  style={{ color: "var(--error-color) !important" }}
                >
                  Please Enter Valid Mobile Number
                </FormHelperText>
              )}
            </div>
            <div className=" flex flex-col">
              <GlobalDropdownField
                name="state"
                label="State*"
                value={contactDetails?.state || ""}
                onChange={handleInputChange}
                placeholder="Select State"
                options={statecityData.map((state) => ({
                  value: state.name,
                  label: state.name,
                }))}
                variant="stateSelect"
                error={errors.state}
                errorMessage={errors.state}
                renderValueFn={(selected) =>
                  !selected ? (
                    <p
                      style={{
                        color: "var(--light-gray)",
                        fontSize: "1rem",
                      }}
                    >
                      Select State
                    </p>
                  ) : (
                    selected
                  )
                }
              />
            </div>

            {/* City Dropdown */}
            <div className=" flex flex-col">
              <GlobalDropdownField
                name="city"
                label="City*"
                value={contactDetails?.city || ""}
                onChange={handleInputChange}
                placeholder="City"
                options={cityArray.map((c) => ({
                  value: c.name,
                  label: c.name,
                }))}
                variant="citySelect"
                error={errors.city}
                errorMessage={errors.city}
                disabled={!contactDetails.state}
                renderValueFn={(selected) =>
                  !selected ? (
                    <p
                      style={{
                        color: "var(--light-gray)",
                        fontSize: "1rem",
                      }}
                    >
                      {contactDetails.state
                        ? "Select City"
                        : "Select State First"}
                    </p>
                  ) : (
                    selected
                  )
                }
              />
            </div>
            <div className=" flex flex-col">
              <CustomInput
                name="clientAddress"
                placeholder="Enter Address"
                title="Address*"
                value={contactDetails?.clientAddress}
                size="small"
                required
                onChange={(e) => {
                  if (!e.target.value.startsWith(" ")) {
                    handleInputChange(e);
                  }
                }}
                onBlur={(e) => {
                  if (saveButtonClicked) {
                    validateForm();
                  }
                }}
                // errorMessage={"Please Enter Address"}
                error={errors.clientAddress}
              />
              {errors.clientAddress && (
                <FormHelperText
                  className=" ml-4"
                  style={{ color: "var(--error-color) !important" }}
                >
                  Please Enter Address
                </FormHelperText>
              )}
            </div>
            <CustomInput
              title="Associated Brands"
              name="associatedBrands"
              value={contactDetails?.associatedBrands}
              onChange={(e) => {
                if (!e.target.value.startsWith(" ")) {
                  handleInputChange(e); // Update the input field dynamically
                }
              }}
              placeholder="Enter Brand Names split by comma"
              fullWidth
              size="small"
            />
          </div>
          <div className="w-full flex justify-end mt-2 ">
            <div>
              <GlobalButton
                variant="primary"
                size="medium"
                isLoading={loading}
                onClick={handleSubmit}
              >
                {isEdit ? "UPDATE" : "SAVE"}
              </GlobalButton>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ClientEditAddModal;
